import axios from 'axios'
import {iamvar_serverUrl} from '../../../public/const.js'
export const ifgrest = axios.create({
  baseURL: iamvar_serverUrl
})
export default ifgrest
